import type { ServerResponseV1 } from "@/http"
import { useMutation } from "@tanstack/vue-query"
import { v1 } from "@/axios"

export enum MoveAlbumPosition {
  Top = "Top",
  Bottom = "Bottom",
}

interface MoveAlbumPositionParams {
  eventVaultId: number
  albumId: number
  position: MoveAlbumPosition
}

export async function moveAlbumPosition(eventVaultId: number, albumId: number, position: MoveAlbumPosition) {
  return await v1.patch<ServerResponseV1<void>>(`/events/${eventVaultId}/albums/${albumId}/move?position=${position}`)
}

export function useMoveAlbumPosition() {
  return useMutation({
    mutationFn: ({ eventVaultId, albumId, position }: MoveAlbumPositionParams) => moveAlbumPosition(eventVaultId, albumId, position),
  })
}
